import {get as getChoice} from 'components/api';
import {choiceById} from 'constants/url';

function getChoiceById(
  idChoice: number,
  idCourse: number,
  idContent: number,
  token: string,
) {
  const url = `${choiceById}?idChoice=${idChoice}&idCourse=${idCourse}&idContent=${idContent}`;
  return getChoice(url, token);
}

export default getChoiceById;
